import type React from 'react';

/**
 * Galaxy map viewer
 */
export function GalaxyMap(): React.ReactElement {
	return (
		<iframe
			title="Galaxy Map IFrame"
			src="https://henrybernberg.maps.arcgis.com/apps/instant/basic/index.html?appid=f8953229bb0e47fcbfbd080640bb57b0"
			width="100%"
			height="100%"
			id="galaxy-map-frame"
		/>
	);
}

export default GalaxyMap;
